module.exports = __webpack_public_path__ + "img/squarecheck.b8186cb2.png";